/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
export var DISPLAY_FORMAT = 'L';
export var ISO_FORMAT = 'YYYY-MM-DD';
export var ISO_MONTH_FORMAT = 'YYYY-MM';
export var ORIENTATION = Object.freeze({
  horizontal: 'horizontal',
  vertical: 'vertical'
});
export var STATE_CHANGE_TYPE = Object.freeze({
  change: 'change',
  moveUp: 'moveUp',
  moveDown: 'moveDown',
  moveLeft: 'moveLeft',
  moveRight: 'moveRight',
  mouseOver: 'mouseOver',
  mouseLeave: 'mouseLeave'
});
export var WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];
export var DEFAULT_MONTHS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
export var DENSITY = {
  high: 'high',
  default: 'default'
};
export var INPUT_ROLE = {
  startDate: 'startDate',
  endDate: 'endDate'
};
export var RANGED_CALENDAR_BEHAVIOR = {
  default: 'default',
  locked: 'locked'
};